import { Alert, Stack } from "@mui/material"
import { ReactElement } from "react"

import { useGetUserData } from "../../../hooks/useGetUserData"
import AppButton from "../../buttons/appButton"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

interface IErrorGettingInviteProps {
    retry: () => void
    errorDetail: string
}

/** Displayed when there is an error getting an invite for a user */
const ErrorGettingInvite = ({
    retry,
    errorDetail,
}: IErrorGettingInviteProps): ReactElement => {
    const { onSignOut } = useGetUserData()

    return (
        <FullScreenTitleContent
            titlePrimaryColor=""
            titleMain="Something went wrong!"
            subtitle="Unfortunately, something has gone wrong in the process of setting up your account. Click the button below to raise a support ticket and our team will jump on this right away"
            content={<Alert severity="warning">{errorDetail}</Alert>}
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <AppButton
                        fullWidth
                        variant="outlined"
                        onClick={() => {
                            onSignOut()
                        }}
                    >
                        Sign out
                    </AppButton>
                    <AppButton
                        fullWidth
                        variant="outlined"
                        color="warning"
                        onClick={() =>
                            window.open(CONFIG.SN_PORTAL_URL, "_blank")
                        }
                    >
                        Support Portal
                    </AppButton>
                    <AppButton fullWidth variant="contained" onClick={retry}>
                        Try Again
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default ErrorGettingInvite
